module.exports = __webpack_public_path__ + "img/api.3d0b7f4e.png";